<template>
    <div class="MetricRegionalPlotter">
        <h1 class="center-text">{{ PanelTitle }}</h1>


        <div v-for="region in Regions" style="margin-top:30px;">
            <div v-if="SeriesDataForRegion(region) != null">
                <h3>{{region}} <span @click="DownloadItemization(region)"><i class="fa fa-download pointer" /> </span></h3>
                <div class="row">
                    <div class="col">
                        <b-col xl="12">
                            <b-card :title="'Weekly ' + region + ' ' + MetricName" align="center">
                                <div style="min-height: 365px;">
                                    <apexchart type="bar"
                                               height="350"
                                               :options="WeeklyPlotSetup.options"
                                               :series="SeriesDataForRegion(region)" />
                                </div>
                            </b-card>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import apexchart from 'vue-apexcharts';

    export default {
        name: "MetricRegionalPlotter",
        props: [
            "StartDate",
            "EndDate",
            "DataEndpoint",
            "PanelTitle",
            "MetricName",
            "CoreProgramId",
            "ChurchOnly"
        ],
        data: function () {
            return {
                DashboardData: [],
                WeeklyPlotSetup: {
                    options: {
                        chart: {
                            type: 'bar'
                        },
                        
                    },
                    series: [{
                        name: "Actual",
                        data: []
                    }]
                },
                Regions: [
                    "Combined",
                    "Orange County",
                    "Los Angeles",
                    "Inland/Desert",
                    "PNW",
                    "Las Vegas",
                    "Santa Barbara"
                ]
            };
        },
        methods: {
            GetData() {
                this.$MasterAPI.ExecuteRequest("GET", this.DataEndpoint, {StartDate: this.StartDate, EndDate: this.EndDate, CoreProgramID: this.CoreProgramId, ChurchOnly: this.ChurchOnly} , this.GetDataSuccess, () => { }, true);
            },
            GetDataSuccess(response) {
                this.DashboardData = response.data.data;
            },
            SeriesDataForRegion(regionName) {
                let output = [];
                this.DashboardData.forEach(function (dateRange) {
                    if (dateRange.RegionSummaries[regionName]) {
                        output.push(dateRange.RegionSummaries[regionName].SeriesData);
                    } else {
                        //do nothing
                    }
                });
                if (output.length > 0) {
                    return [{
                        name: "Actual",
                        data: output
                    }];
                } else {
                    return null;
                }
                
            },
            DownloadItemization(regionName) {
                console.log("downloading itemizaiton for " + regionName);
                this.$MasterAPI.ExecuteFileRequest(this.DataEndpoint + "Itemization", { RegionName: regionName, CoreProgramID: this.CoreProgramId, StartDate: this.StartDate, EndDate: this.EndDate, ChurchOnly: this.ChurchOnly });
            }
        },
        watch: {
            StartDate(newDate, oldDate) {
                this.GetData();
            },
            EndDate(newDate, oldDate) {
                this.GetData();
            },
            PanelTitle(newData, oldData) {
                this.GetData();
            }
        },
        components: {
            apexchart
        },
        mounted() {
            this.GetData();
        },
        computed: {

        }
    }
</script>

<style scoped>

</style>